// extracted by mini-css-extract-plugin
export default {"signatureField":"Lb_GJS","header":"O_0iMU","inputContainer":"d5Piwv"};